<script setup>
import { onMounted, ref, watchEffect } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Icons/Logo'
import ButtonHamburger from '@/Shared/Buttons/ButtonHamburger'
import ButtonStar from '@/Shared/Buttons/ButtonStar'
import Navi from '@/Shared/Navi/Navi'
import Favorite from '@/Shared/Favorite/Favorite'
import Overlay from '@/Shared/Overlay'

const naviOpen = ref(false)
const favoriteOpen = ref(false)
const htmlRef = ref()

const closeNavi = () => {
  naviOpen.value = false
}

const closeFavorite = () => {
  favoriteOpen.value = false
}

onMounted(() => {
  htmlRef.value = document.getElementsByTagName('html')[0]
  watchEffect(() => {
    if (naviOpen.value === true) {
      htmlRef.value.classList.add('navi-open')
    } else {
      htmlRef.value.classList.remove('navi-open')
    }
    if (favoriteOpen.value === true) {
      htmlRef.value.classList.add('favorite-open')
    } else {
      htmlRef.value.classList.remove('favorite-open')
    }
  })
  Inertia.on('start', () => {
    closeFavorite()
  })
})
</script>

<template>
  <div class="header-wrapper">
    <div class="header fixed z-10 top-0 w-screen flex items-center justify-center bg-white xl:bg-transparent h-[55px] md:h-[75px] xl:h-0 shadow-[0_1px_1px_rgba(0,0,0,0.1)] xl:shadow-none">
      <ButtonHamburger class="md:scale-[1.3] md:left-[10px] xl:hidden" @click="naviOpen = true" />
      <Link href="/" class="p-[15px] box-border xl:hidden"><Logo class="pt-[2px] h-auto w-[210px] md:w-[300px]" type="green1" /></Link>
      <ButtonStar class="border border-solid bg-white border-[rgba(0,0,0,0.13)] shadow-[0_1px_1px_rgba(0,0,0,0.13)] h-[35px] w-[35px] rounded-[5px] scale-[0.8] md:scale-[1.0] right-[10px] md:right-[30px] xl:mt-[70px]" @click="favoriteOpen = true" />
    </div>

    <transition name="slide-right">
      <Navi v-show="naviOpen" class="z-[60] xl:z-30" @close="closeNavi" />
    </transition>
    <transition name="fade">
      <Overlay v-if="naviOpen" class="z-50 xl:hidden" @click="closeNavi" />
    </transition>

    <transition name="slide-left">
      <Favorite v-if="favoriteOpen" class="z-50" @close="closeFavorite" />
    </transition>
    <transition name="fade">
      <Overlay v-if="favoriteOpen" class="z-40" @click="closeFavorite" />
    </transition>
  </div>
</template>
